import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-menu.css';

var getClassNameList = classNames.bind(styles);
var UitkMenuListItem = /** @class */ (function (_super) {
    __extends(UitkMenuListItem, _super);
    function UitkMenuListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMenuListItem.prototype.render = function () {
        var _a = this.props, analytics = _a.analytics, className = _a.className, href = _a.href, iconComponent = _a.iconComponent, iconName = _a.iconName, label = _a.label, Link = _a.Link, onClick = _a.onClick, role = _a.role, tabIndex = _a.tabIndex, target = _a.target, selected = _a.selected, disabled = _a.disabled, to = _a.to, typeAnchor = _a.typeAnchor;
        var Tag = typeAnchor ? 'a' : 'button';
        var onClickCapture = analytics && analyticsTracker.bind(this, analytics);
        var additionalProps = __assign({ className: className, onClick: function (event) {
                if (onClick) {
                    onClick(event);
                }
            }, onClickCapture: onClickCapture, role: role, selected: selected, tabIndex: tabIndex, target: target }, (to && { to: to }) // This is to prevent the "to" prop from getting set as undefined when it is not set explicitly and provided as part of the Link
        );
        /* istanbul ignore next */
        if (Link) {
            return React.cloneElement(Link, additionalProps);
        }
        additionalProps.className = getClassNameList(className, {
            'uitk-list-item-disabled': disabled
        });
        return (React.createElement(Tag, __assign({}, additionalProps, (typeAnchor && { href: href }), (selected && { 'aria-checked': selected }), (disabled && { 'aria-disabled': disabled, tabIndex: -1 })),
            iconName && iconComponent == null && (React.createElement(UitkIcon, { className: getClassNameList('uitk-menu-list-item-icon'), name: iconName })),
            iconComponent && React.createElement("span", { className: getClassNameList('uitk-menu-list-item-icon') }, iconComponent),
            React.createElement("span", { className: getClassNameList('uitk-menu-list-item-label') }, label),
            selected && React.createElement(UitkIcon, { className: getClassNameList('uitk-menu-list-item-check'), name: "check" })));
    };
    UitkMenuListItem.displayName = 'UitkMenuListItem';
    return UitkMenuListItem;
}(React.Component));

export { UitkMenuListItem };
